import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DesignPartnerFeedbackService } from '../../services/design-partner-feedback.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-design-partner-feedback',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './design-partner-feedback.component.html',
  styleUrl: './design-partner-feedback.component.less',
})
export class DesignPartnerFeedbackComponent implements OnInit {
  feedbackList: any[] = [];
  note: string = '';
  showAddForm: boolean = false;
  isLoading: boolean = false;
  isSubmitting: boolean = false;
  noFeedbackMessage: string = 'No feedback submitted yet.';

  constructor(
    private feedbackService: DesignPartnerFeedbackService,
    private authService: AuthService,
    private toaster: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const user = this.authService.getUser();
    if (user?.role !== 'design_partner') {
      this.router.navigate(['/dashboard']);
      return;
    }
    this.loadFeedback();
  }

  loadFeedback(): void {
    this.isLoading = true;
    this.feedbackService.getFeedback().subscribe({
      next: (response: any) => {
        this.feedbackList = response?.data ?? response ?? [];
        if (!Array.isArray(this.feedbackList)) {
          this.feedbackList = [];
        }
        this.isLoading = false;
        if (this.feedbackList.length === 0) {
          this.noFeedbackMessage = 'No feedback submitted yet.';
        }
      },
      error: () => {
        this.isLoading = false;
        this.noFeedbackMessage = 'Failed to load feedback. Please try again later.';
        this.toaster.showToast('Failed to load feedback', 'error');
      },
    });
  }

  openAddForm(): void {
    this.note = '';
    this.showAddForm = true;
  }

  cancelAddForm(): void {
    this.showAddForm = false;
    this.note = '';
  }

  submitFeedback(): void {
    const trimmedNote = this.note.trim();
    if (!trimmedNote) {
      this.toaster.showToast('Please enter your feedback', 'error');
      return;
    }

    this.isSubmitting = true;
    this.feedbackService.submitFeedback(trimmedNote).subscribe({
      next: (response: any) => {
        this.isSubmitting = false;
        this.showAddForm = false;
        this.note = '';
        this.toaster.showToast(
          response?.message || 'Feedback submitted successfully',
          'success'
        );
        this.loadFeedback();
      },
      error: (error) => {
        this.isSubmitting = false;
        const message =
          error?.error?.message ||
          error?.error?.error ||
          'Failed to submit feedback';
        this.toaster.showToast(message, 'error');
      },
    });
  }
}
